import { useRef } from 'react';

let globalIdCounter = 0;

export const useId = (prefix = 'id') => {
    const idRef = useRef<string | null>(null);

    if (idRef.current === null) {
        const timestamp = Date.now();
        idRef.current = `${prefix}-${timestamp}-${++globalIdCounter}`;
    }

    return idRef.current;
};

export const withId = <P extends object>(Component: React.ComponentType<P>, prefix = 'id') => {
    return (props: P) => {
        const id = useId(prefix);
        return <Component {...props} id={id} />;
    };
};
